import { useAsyncOperation } from "@core/hooks/use-async-operation";

import { localeManager, prospectRequestManager } from "@core/service-container";
import { ProspectRequestConfig } from "@domain/prospect-request/prospect-request";
import { useCallback, useEffect, useState } from "react";

interface UseProspectRequestHook {
	config: ProspectRequestConfig | undefined;
	configLoading: boolean;
	configError: boolean;
}

export function useProspectRequestLoading(locale?: string): UseProspectRequestHook {
	const [config, setConfig] = useState<ProspectRequestConfig | undefined>(undefined);

	const [fetchConfig, configLoading, configError] = useAsyncOperation(
		useCallback(async () => {
			const [prospectRequestConfig] = await Promise.all([
				prospectRequestManager.prepareProspectRequest(locale),
				localeManager.fetchSupportedLocales().catch(() => undefined),
			]);
			setConfig(prospectRequestConfig);
		}, [locale]),
		{
			initialLoadingState: true,
		},
	);

	useEffect(() => {
		fetchConfig();
	}, [fetchConfig]);

	return {
		config,
		configLoading,
		configError,
	};
}
